import { render, staticRenderFns } from "./norm_page.vue?vue&type=template&id=5dc1baa8&scoped=true&"
import script from "./norm_page.vue?vue&type=script&lang=js&"
export * from "./norm_page.vue?vue&type=script&lang=js&"
import style0 from "./norm_page.vue?vue&type=style&index=0&id=5dc1baa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1baa8",
  null
  
)

export default component.exports